// primer is a baseline CSS library that sets up Opendoor defaults
import '@opendoor/primer/stylesheets/primer.css';
import '@opendoor/silica/dist/mosaic.css';
import '@blueprintjs/core/lib/css/blueprint.css';

import { ApolloProvider } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom';
import '@opendoor/silica/dist/mosaic.css';
import App from './App';
import { clientFromUrl } from './setupAthenaClient';

import { loadSentry } from '@opendoor/observability';
loadSentry('https://93118d4616254e849677af1460d826ad@o117144.ingest.sentry.io/6058924');

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={clientFromUrl()}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
